import { VueAutosuggest } from "vue-autosuggest";
import debounce from "lodash/debounce";

import CheckedIcon from "@/assets/images/icons/checked.svg?inline";
import SliderField from "@/components/sliderField";
import LoaderLocation from "@/components/LoaderLocation";
import LoaderHeart from "@/components/LoaderHeart";

import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

import { GET_SUGGESTIONS, GET_ADDRESSES } from "../gql/HomeQueries";

export default {
  name: "quizField",

  data() {
    return {
      placesQuery: "",
      placesRequestQuery: "",
      selected: "",
      places: [],
      skipPlacesQuery: true,

      checkedSelect: [],
      rangeFields: {
        min: "",
        max: ""
      },
      rangeFieldsInvalid: false,
      rangeMinInvalid: false,
      rangeMaxInvalid: false,
      showAnswerTooltip: false,
      sliderValues: [],

      isShowLoader: true,

      addresses: [],
      skipAddressesQuery: true
    };
  },

  props: ["question", "isLoading", "selectedPropertyType", "activeQuestionId"],

  apollo: {
    places: {
      query: GET_SUGGESTIONS,
      variables() {
        return {
          address: this.placesRequestQuery
        };
      },

      skip() {
        return this.skipPlacesQuery;
      },
      result() {
        this.skipPlacesQuery = true;
      }
    },

    addresses: {
      query: GET_ADDRESSES,
      variables() {
        return {
          input: this.addressesRequestQuery
        };
      },
      skip() {
        return this.skipAddressesQuery;
      },
      result() {
        this.skipAddressesQuery = true;
      }
    }
  },

  mounted: function() {
    if (
      this.question.questionType == "range" ||
      this.question.questionType == "price"
    ) {
      this.sliderValues = this.question.answers.reduce((total, item) => {
        if (item.id === "current" || item.id === "min") {
          total.push(Number(item.text));
        }

        return total;
      }, []);
    } else {
      for (let answer in this.question.answers) {
        this.sliderValues.push(+this.question.answers[answer].text);
      }
    }
  },

  computed: {
    filteredOptions() {
      const filtered = [];

      if (!this.placesQuery) {
        return [];
      }

      let options = [];

      if (this.question.questionType == "exact_location") {
        options = this.addresses;
      } else {
        options = this.places;
      }

      options.forEach(r => {
        filtered.push({
          label: r.type,
          data: r.places,
          limit: 5,
          onSelected: selected => {
            this.selected = selected.item;
          }
        });
      });

      return Object.freeze(filtered);
    },

    originValue() {
      if (this.question && this.question.answers) {
        return [+this.question.answers[0].text, 1000000];
      } else {
        return [10000, 100000000];
      }
    },

    answerBadgeClass() {
      // class="[ !!answer.badge ? 'col-auto' : 'col-sm-4 mb-3']"
      let cssClass = "col-sm-4 mb-3";

      switch (this.question.answersType) {
        case "text_badge":
          if (this.question.answers.length <= 4) {
            cssClass = "col-auto";
          } else {
            cssClass = "mb-3";
          }
          break;

        case "image_badge":
          if (this.question.answers.length <= 4) {
            cssClass = "col-auto";
          } else {
            cssClass = "mb-3";
          }
          break;

        case "image":
          if (this.question.answers.length > 0) {
            cssClass = `col-6 col-md-${12 / this.question.answers.length}`;
          } else {
            cssClass = "mb-3";
          }
          break;

        default:
          cssClass = "col-sm-4 mb-3";
      }

      return cssClass;
    },

    homeStyleAnswers() {
      return this.$store.state.homeStyleAnswers;
    }
  },

  watch: {
    placesQuery: debounce(function(newQuestion) {
      if (newQuestion.length >= 2) {
        if (this.question.questionType == "exact_location") {
          // trigger ADDRERSSES request
          this.addressesRequestQuery = newQuestion;
          this.skipAddressesQuery = false;
        } else {
          // trigger PLACES request
          this.placesRequestQuery = newQuestion;
          this.skipPlacesQuery = false;
        }
      }
    }, 300),

    checkedSelect: function(newNames) {
      if (newNames.length > 0 && this.question.questionType != "multi_select") {
        this.nextQuestion();
      }
    },

    activeQuestionId(newType) {
      if (newType == this.question.questionType) {
        this.initLoadingTimeOut();
      } else {
        this.isShowLoader = true;
      }
    }
  },

  methods: {
    initLoadingTimeOut() {
      setTimeout(() => {
        if (this.question.questionType == "text_loader") {
          this.nextQuestion(true);
        } else {
          this.isShowLoader = false;
        }
      }, 4000);
    },

    clickSelectOne(answer) {
      if (
        answer.value == this.checkedSelect &&
        this.question.questionType != "multi_select"
      ) {
        this.nextQuestion();
      }
    },

    selectHandler(item) {
      this.selected = item;
      this.nextQuestion();
    },

    getSuggestionValue(suggestion) {
      return suggestion.item.description;
    },

    updateSliderRange(values) {
      this.sliderValues = values;
    },

    nextQuestion(isSkip = false) {
      let data = {
        type: this.question.questionType
      };

      if (isSkip) {
        this.checkedSelect = [];
        data.filter = {
          tagId: this.question.tagId,
          value: JSON.stringify(this.checkedSelect)
        };
      } else {
        switch (this.question.questionType) {
          case "main_desired_location":
          case "additional_location":
          case "exact_location":
            // data.placeId = this.selected.item ? this.selected.item.placeId : "";

            data.filter = {
              tagId: this.question.tagId,
              value: JSON.stringify(
                this.selected.item ? this.selected.item.placeId : ""
              )
            };

            break;

          case "range":
          case "price":
            if (this.sliderValues[1] < this.sliderValues[0]) {
              this.sliderValues[1] = this.sliderValues[0];
            }
            data.filter = {
              tagId: this.question.tagId,
              value: JSON.stringify(this.sliderValues)
            };

            break;

          default:
            data.filter = {
              tagId: this.question.tagId,
              value: JSON.stringify(this.checkedSelect)
            };

            break;
        }
      }

      this.$emit("triggerNextQuestion", data);
    },

    // Forr summarry slide
    collectHomeStyleAnswers(data) {
      if (this.question.questionsGroup == "home_style") {
        let answer = {
          id: data.id,
          tagId: this.question.tagId,
          text: data.text,
          image: data.image,
          cartoonImage: data.cartoonImage
        };

        this.$store.commit("pushHomeStyleAnswer", answer);
      }
    }
  },

  components: {
    VueAutosuggest,
    SliderField,
    CheckedIcon,
    VueSlider,
    LoaderLocation,
    LoaderHeart
  }
};
